import axios from 'axios'

import type { TCustomerFormZipCode } from '../types/client-form-promise-zip-code.type'

export type TCustomerFormLoadZipCodeService = {
  payload: {
    zipCode: string
  }
}

export const customerFormLoadZipCodeService = async ({
  payload,
}: TCustomerFormLoadZipCodeService): Promise<TCustomerFormZipCode> => {

	try {
		const response = await axios.get(
			`https://viacep.com.br/ws/${payload.zipCode}/json`,
			{
				timeout: 10000,
			},

		)

	if (response.data.erro) {
	  throw new Error('Dados não encontrados para o CEP informado');
	}

	return response.data;
  } catch (error) {
	console.error('Error loading zip code:', error);
	throw error;
  }

}
